var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m11.255 11.43-8.178 8.677v.008a2.21 2.21 0 0 0 3.256 1.329l.023-.016 9.2-5.306z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "m19.526 9.955-.008-.007-3.97-2.304-4.477 3.986 4.492 4.492 3.955-2.28a2.212 2.212 0 0 0 .008-3.887"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M3.077 3.643A2.3 2.3 0 0 0 3 4.211v15.336c0 .2.023.384.077.568l8.455-8.455z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "m11.317 11.875 4.231-4.231-9.192-5.33a2.218 2.218 0 0 0-3.28 1.321z"
  })));
};
export default SvgGooglePlay;